import React from 'react';
import { Box, Button, Chip } from '@curves/ui-base';

import {Grid} from '@mui/material';
import {ReadTextField} from '@Local/Components';
import {formatCurrencyFn, isFunction} from '@Util/utils';
import {parseDate} from '@Util/moment.util';
import clsx from 'clsx';
import {DATE_TIME_STANDARD, ORDER_STATUS_COLOR_MATCH} from '@Constants/appConfig';
/**
 * 發票折讓卡片組件
 *
 * 功能：
 * - 顯示發票折讓相關資訊
 * - 提供折讓操作按鈕
 * - 支援折讓取消功能
 *
 * @component
 * @param {Object} props - 組件屬性
 * @param {string} props.className - 自定義樣式類名
 * @param {Object} props.sourceData - 折讓資料
 * @param {Object} props.dialogRef - 彈窗引用
 * @param {Function} props.refresh - 刷新回調
 * @returns {JSX.Element} 發票折讓卡片
 */
const InvoiceAllowanceCard = ({className, sourceData, dialogRef, refresh}) => {
    const {openOrderAllowanceCancelDialog} = dialogRef.current || {};
    /**
     * 處理開啟折讓取消彈窗
     */
    const handleOpenOrderAllowanceCancelDialog = () => {
        isFunction(openOrderAllowanceCancelDialog) && openOrderAllowanceCancelDialog(sourceData, refresh);
    }
    return (
        <Box className={clsx(className, "invoice-allowance-card")}>
            <Grid container spacing={1}>
                <Grid xs={6} item>
                    <ReadTextField label="金額">
                        {formatCurrencyFn(sourceData?.allowanceAmount)}
                    </ReadTextField>
                </Grid>
                <Grid xs={6} item>
                    <ReadTextField label="狀態">
                        <Chip label={sourceData?.allowanceStatusText} color={ORDER_STATUS_COLOR_MATCH[sourceData?.allowanceStatusColor]}/>
                    </ReadTextField>
                </Grid>
                <Grid xs={6} item>
                    <ReadTextField label="日期">
                        {parseDate(sourceData?.invoiceDate, DATE_TIME_STANDARD.DISPLAYDATE)}
                    </ReadTextField>
                </Grid>
                <Grid xs={6} item>
                    <ReadTextField label="原因">
                        {sourceData?.invalidReason}
                    </ReadTextField>
                </Grid>
                {
                    sourceData?.canInvalid ? (
                        <Grid xs={12} item>
                            <Button color="error" variant="outlined" size={'small'} onClick={handleOpenOrderAllowanceCancelDialog}>
                                取消折讓
                            </Button>
                        </Grid>
                    ) : null
                }
            </Grid>
        </Box>
    );
};
export default InvoiceAllowanceCard;
